module.exports = __webpack_public_path__ + "static/media/anniu4.419dc61c.png";